import React from 'react';
import { SVGProps } from './types';

const ProceedIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <g clipPath="url(#clip0_2369_22468)">
        <path
          stroke="currentColor"
          strokeWidth="1.25"
          d="M3.333 10H16.31m-3.81 4.167L16.667 10 12.5 5.833"
        />
      </g>
      <defs>
        <clipPath id="clip0_2369_22468">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ProceedIcon };
